<template>
  <UiSyncStatus
    v-model:open="isOpen"
    :state="presentationState"
    :label="label"
    :pending="pendingActions"
    compact
  >
    <template #details>
      <div class="sync-details-content p-2.5 text-xs space-y-2">
        <div v-if="totalWords > 0" class="flex items-center gap-2">
          <span
            class="rounded-full px-2 py-0.5 text-[11px] font-medium bg-[var(--ui-surface-muted)] border border-[var(--ui-border)] text-[var(--ui-text-subtle)]"
          >
            {{ totalWords }} words offline
          </span>
        </div>

        <p
          v-if="pendingWords > 0 || pendingPreferences > 0"
          class="text-[11px] text-[var(--ui-text-subtle)]"
        >
          {{ pendingWords }} word changes · {{ pendingPreferences }} preference changes pending
        </p>

        <p
          class="text-[11px] font-medium"
          :class="
            syncState.realtime === 'connected'
              ? 'text-emerald-600 dark:text-emerald-400'
              : 'text-amber-600 dark:text-amber-400'
          "
        >
          {{
            syncState.realtime === 'connected'
              ? 'Realtime connected'
              : 'Periodic 3-way merge synchronization active'
          }}
        </p>

        <p
          v-if="!isOnline || pendingActions > 0"
          class="text-amber-600 dark:text-amber-400 leading-relaxed"
        >
          Changes saved on this device synchronize automatically via 3-way merge when connected.
        </p>

        <p v-if="lastSyncedAt" class="opacity-70 text-[var(--ui-text-muted)]">
          Last synchronized: {{ new Date(lastSyncedAt).toLocaleTimeString() }}
        </p>

        <p v-if="lastError" class="text-red-600 dark:text-red-400 font-medium">
          {{ lastError }}
        </p>

        <div class="pt-1">
          <UiButton
            size="sm"
            variant="secondary"
            class="w-full justify-center text-xs"
            :disabled="!isOnline || isSyncing"
            @click="onSynchronizeNow"
          >
            <i class="fa-solid fa-arrows-rotate mr-1.5" :class="{ 'fa-spin': isSyncing }"></i>
            <span>Synchronize now</span>
          </UiButton>
        </div>
      </div>
    </template>
  </UiSyncStatus>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { UiSyncStatus, UiButton } from '../ui';
import { useSyncStatus } from '../composables/useSyncStatus';

const isOpen = ref(false);
const {
  presentationState,
  label,
  pendingActions,
  pendingWords,
  pendingPreferences,
  totalWords,
  isSyncing,
  lastSyncedAt,
  isOnline,
  lastError,
  syncState,
  retrySync,
} = useSyncStatus();

const onSynchronizeNow = async () => {
  await retrySync();
};
</script>

<style scoped>
.sync-details-content {
  min-width: 15rem;
  max-width: 22rem;
}
</style>
